var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-8 text-center"},[_c('img',{attrs:{"src":require("../../src/assets/logo_contago_erp.png"),"height":"200"},on:{"click":function($event){return _vm.funcion()}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }